namespace TabAurous.Common {
    export interface CommonProduct {
        ProductId?: number;
        ProductTypeId?: number;
        ProductCode?: string;
        ProductName?: string;
        AttributeId?: number;
        Pieces?: number;
        ExportPieces?: number;
        Weight?: number;
        Volume?: number;
        Volume1?: number;
        Volume2?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        Rate?: number;
        UnitLabour?: number;
        CalcOnId?: number;
        CalcOn?: string;
        CalcUnitId?: number;
        CalcUnit?: string;
        CostMethodId?: number;
        SettingId?: number;
        ImageName?: string;
        Image1?: string;
        Image2?: string;
        Image3?: string;
        Video1?: string;
        Video2?: string;
        Remark?: string;
        HasBom?: boolean;
        SKU?: string;
        HSN?: string;
        TaxCode?: string;
        Purity?: number;
        Attribute?: string;
        ProductTypeCode?: string;
        ItemTypeId?: number;
        ItemType?: string;
        CategoryId?: number;
        CategoryCode?: string;
        SubCategoryId?: number;
        SubCategoryCode?: string;
        KaratId?: number;
        KaratCode?: string;
        MetalColorId?: number;
        MetalColorCode?: string;
        ProductSizeId?: number;
        ProductSizeCode?: string;
        StoneSizeId?: number;
        StoneSizeCode?: string;
        BrandId?: number;
        BrandCode?: string;
        CollectionId?: number;
        CollectionCode?: string;
        SuperTypeId?: number;
        SuperTypeCode?: string;
        ShapeId?: number;
        ShapeCode?: string;
        SieveId?: number;
        SieveCode?: string;
        GroupSieveId?: number;
        GroupSieveCode?: string;
        QualityId?: number;
        QualityCode?: string;
        StoneColorId?: number;
        StoneColorCode?: string;
        RefNo?: string;
        StampId?: number;
        StampCode?: string;
        MetalId?: number;
        MetalCode?: string;
        MF?: number;
        MFAmount?: number;
        StoneCutId?: number;
        StoneCutCode?: string;
        StonePolishId?: number;
        StonePolishCode?: string;
        StoneSymmetryId?: number;
        StoneSymmetryCode?: string;
        StoneFluorescenceId?: number;
        StoneFluorescenceCode?: string;
        StoneCuletId?: number;
        StoneCuletCode?: string;
        StoneGirdleId?: number;
        StoneGirdleCode?: string;
        StoneTable?: string;
        StoneDepth?: string;
        BOMDetails?: CommonProductBOM[];
        LaborDetails?: CommonLabor[];
    }
}
